import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Do I get the full prompts or just ideas?',
  a: 'The full prompts. All 120 are complete and ready to copy and paste. You only fill in the [brackets] with your own de-identified facts.'
}, {
  q: 'Can I use it during a live call?',
  a: 'No. Never use AI during a live call. These prompts are for after the call: on a break, at end of shift or at home. The AI never decides priorities, codes or units, and never gives instructions to callers. Your protocols, CAD and training do that.'
}, {
  q: 'Is it allowed to use AI at my agency?',
  a: 'Policies vary. Always follow your agency’s AI policy. Every prompt uses de-identified fields (Caller A, Unit Number, block-level location) so you never paste names, phone numbers, dates of birth or plates into an AI chat. Real identifiers stay inside CAD or RMS.'
}, {
  q: 'Will the AI make things up?',
  a: 'Every prompt tells the AI to use only the facts you give it and to ask you when something is missing. You always review and correct the draft before anything goes into an official record.'
}, {
  q: 'Which AI does it work with?',
  a: 'It works with ChatGPT, Claude and Gemini. Copy the prompt, fill in the brackets and paste it into the AI you already use.'
}, {
  q: 'Does it work outside the US?',
  a: 'Yes. It is written for dispatchers and telecommunicators in the US, Canada, the UK, Australia and New Zealand, and you can tell the AI your spelling and your agency’s terms.'
}, {
  q: 'Do I need to be a tech expert?',
  a: 'No. If you can copy and paste, you can use this toolkit on your phone, tablet or computer.'
}, {
  q: 'How do I receive it? Is it a one-time payment?',
  a: 'You get instant access to the PDFs right after payment. Pay once and keep them. No subscription.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Frequently asked questions" className="bg-transparent" data-id="element-40" data-mp="2pmwv7l9j656d">
      <div className="mx-auto max-w-3xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "14px"
    }} data-id="element-41" data-mp="2kw6oo4pdbwa3">
        <h2 className="text-center font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-42" data-mp="2fwaka4cre2u0">
          ❓ Frequently Asked Questions
        </h2>
        <div className="mt-10 divide-y divide-grape/10 overflow-hidden rounded-2xl border border-grape/15 bg-white" data-id="element-43" data-mp="2azbprkp6ntva">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-44" data-mp="33npq473qv2a0" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-lilac-soft focus:outline-none focus-visible:bg-lilac-soft" data-id="element-45" data-mp="33kbmkvjcgn0z">
                  <span className="text-sm font-bold text-plum sm:text-base" data-id="element-46" data-mp="1n61zs5ur36c9">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-blush" data-id="element-47" data-mp="1j8ntalygfcny" /> : <PlusIcon className="h-5 w-5 shrink-0 text-plum/40" data-id="element-48" data-mp="3uuppyy8d40j9" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-49" data-mp="2pcdwamyfdc4">
                  <div className="overflow-hidden" data-id="element-50" data-mp="cfx7tkrontop">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-plum/70" data-id="element-51" data-mp="cgp30uhdbpeg">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}